import { Signal } from "solid-js";
import STDataSourceEditor, { DataSourceType } from "../st-data-source-editor/st-data-source-editor";
import './data-source-editor.css'

interface DataSourceEditorProps {
    queryType: Signal<DataSourceType>
    query: Signal<string>
}

export default function DataSourceEditor(props: DataSourceEditorProps) {
    return (
        <div class="data-source-editor">
            <STDataSourceEditor query={props.query} type={props.queryType} />
        </div>
    )
}
